import { useCallback, useMemo } from 'react';
import { Button, Form } from 'react-bootstrap';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { useFormikContext, Formik } from 'formik';

import styles from '@components/Profile/EndUser/EndUserProfilesTable.module.css';

import { updateQueryStringOnFieldChange } from '@components/Filters/Filters';
import { BootstrapGenericTable } from '@components/Table/Table';
import { useThrottle } from '@features/useThrottle';

const renderActionsCell = ({ row }) => {
  const navigate = useNavigate();
  const { id } = row.original;
  return (
    <Button
      variant="didxl"
      onClick={() => navigate(`/profiles/edit/${id}`)}
      size="sm"
    >
      Edit
    </Button>
  );
};

export const BlockedButton = ({ blocked }) => {
  if (blocked) {
    return (
      <Button variant="btn btn-didxl-danger btn-sm " size="sm">
        Blocked
      </Button>
    );
  }

  return null;
};

const renderBlockedCell = ({ row }) => (
  <BlockedButton blocked={row.original.blocked} />
);

const renderProfileNameHeader = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { handleChange, handleBlur, values } = useFormikContext();
  const throttle = useThrottle((event) => {
    updateQueryStringOnFieldChange(event, { searchParams, setSearchParams });
  }, 500);
  const throttledChangeHandler = useCallback(
    (event) => {
      handleChange(event);
      throttle(event);
    },
    [throttle]
  );
  return (
    <Form.Group className="mb-3" controlId="formGroupInvoiceID">
      <Form.Label>End user name</Form.Label>
      <Form.Control
        type="input"
        name="profileName"
        size="sm"
        value={values.profileName}
        onChange={throttledChangeHandler}
        onBlur={handleBlur}
        placeholder="Search"
      />
    </Form.Group>
  );
};

const renderCountryHeader = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { handleChange, handleBlur, values } = useFormikContext();
  const throttle = useThrottle((event) => {
    updateQueryStringOnFieldChange(event, { searchParams, setSearchParams });
  }, 500);
  const throttledChangeHandler = useCallback(
    (event) => {
      handleChange(event);
      throttle(event);
    },
    [throttle]
  );
  return (
    <Form.Group className="mb-3" controlId="formGroupInvoiceID">
      <Form.Label>Country</Form.Label>
      <Form.Control
        type="input"
        name="country"
        size="sm"
        value={values.country}
        onChange={throttledChangeHandler}
        onBlur={handleBlur}
        placeholder="Search"
      />
    </Form.Group>
  );
};

export const EndUserProfilesTable = ({ useData }) => {
  const [searchParams] = useSearchParams();
  const profileName = searchParams.get('profileName') || '';
  const country = searchParams.get('country') || '';
  const filterData = {
    country,
    name: profileName,
  };

  const columns = useMemo(
    () => [
      { id: 'profileID', Header: '', accessor: 'id' },
      {
        id: 'profileName',
        Header: renderProfileNameHeader,
        accessor: 'name',
      },
      {
        Header: 'Blocked',
        accessor: 'blocked',
        className: 'col-md-1',
        Cell: renderBlockedCell,
      },
      { Header: 'Name', accessor: 'name' },
      {
        id: 'area',
        Header: 'City',
        accessor: 'area',
      },
      {
        id: 'country',
        Header: renderCountryHeader,
        accessor: 'country',
      },
      {
        id: 'action',
        Header: 'Action',
        className: 'col-md-1',
        Cell: renderActionsCell,
      },
    ],
    []
  );
  return (
    <Formik
      enableReinitialize
      initialValues={{ country, profileName }}
      onSubmit={() => {}}
    >
      <BootstrapGenericTable
        columns={columns}
        useData={useData}
        filterData={filterData}
        tableProps={() => ({ bordered: true })}
        headerProps={() => ({
          className: `align-top sticky-top bg-white ${styles.topAdjustedForNavbars}`,
        })}
        paginated
        hiddenColumns="profileID"
      />
    </Formik>
  );
};
